/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_upper.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns a new string representing the input string converted to upper case.',
  examples: [
    'ROW message = "Some Text"\n| EVAL message_upper = TO_UPPER(message)',
  ],
  params: {
    str: 'String expression. If `null`, the function returns `null`. The input can be a single-valued column or expression, or a multi-valued column or expression. ',
  },
};

export default docs;
